import script from "./DataGroupRequestTransferModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataGroupRequestTransferModal.vue?vue&type=script&lang=ts&setup=true"

import "./DataGroupRequestTransferModal.vue?vue&type=style&index=0&id=db2a10bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db2a10bc"]])

export default __exports__